<span>{{ 'submitProposal.selectedText' | translate }}</span>

@if (submitWholeProgram()) {
  <pa-add-course-list-header [title]="submitInfo()!.electives.examComponentName" class="course-list-header__level1" />
}

@for (selectedElectivesCourseGroup of selectedElectivesCourseGroups(); track selectedElectivesCourseGroup.title) {
  <pa-add-course-list-header
    [title]="selectedElectivesCourseGroup.title"
    [ngClass]="{ 'course-list-header__level2': submitWholeProgram() }"
  />

  @for (courseData of selectedElectivesCourseGroup.courseDataList; track courseData.uniqueId) {
    <pa-add-course-list-item [showCheckbox]="false" [selected]="true" [selectable]="false" [disabled]="true">
      <pa-course-item [courseData]="courseData" showCategory hideShowInfo hideTimeslots />
    </pa-add-course-list-item>
  }
}

@for (group of otherCourseGroups(); track group.title) {
  @if (group.submitCourseItems.length) {
    <pa-add-course-list-header [title]="group.title" [subTitle]="group.subTitle" class="course-list-header__level1" />

    @for (courseItem of group.submitCourseItems; track $index) {
      <pa-add-course-list-item [showCheckbox]="false" [selected]="true" [selectable]="false" [disabled]="true">
        <pa-course-item [courseData]="courseItem.courseData" hideShowInfo hideTimeslots />
      </pa-add-course-list-item>
    }
  }
}
